import {
  Box,
  Button,
  Flex,
  Image,
  Link,
  Text,
} from '@chakra-ui/react';
import nimsiClinicLogo from 'assets/img/brand/nimsi-clinic-logo.jpg';
import { UNITIX_SUPPORT_URL } from 'constants';
import React from 'react';

const BRAND_NAVY = '#01416d';
const BRAND_ACCENT = '#2b8bc4';

export default function SidebarDocs() {
  const bgColor = `linear-gradient(145deg, ${BRAND_NAVY} 0%, #013256 55%, #01213c 100%)`;

  return (
    <Flex
      direction="column"
      align="stretch"
      bg={bgColor}
      borderRadius="20px"
      position="relative"
      overflow="visible"
      boxShadow="0 12px 32px rgba(1, 65, 109, 0.35)"
      p="16px"
      minH="168px"
      w="100%"
    >
      <Box
        position="absolute"
        top="-24px"
        right="-24px"
        w="100px"
        h="100px"
        borderRadius="full"
        bg={BRAND_ACCENT}
        opacity={0.1}
        pointerEvents="none"
      />
      <Flex align="center" gap="12px" mb="14px" position="relative" zIndex={1}>
        <Flex
          flexShrink={0}
          w="64px"
          h="64px"
          borderRadius="14px"
          overflow="hidden"
          border="2px solid"
          borderColor="whiteAlpha.400"
          align="center"
          justify="center"
          boxShadow="0 6px 16px rgba(0, 0, 0, 0.25)"
        >
          <Image
            src={nimsiClinicLogo}
            w="100%"
            h="100%"
            objectFit="cover"
            alt="NIMSI Clinic"
          />
        </Flex>
        <Flex direction="column" align="flex-start" minW={0} flex="1">
          <Text
            fontSize="sm"
            color="white"
            fontWeight="800"
            letterSpacing="0.06em"
            lineHeight="1.25"
          >
            NIMSI Clinic
          </Text>
          <Text
            fontSize="xs"
            color="whiteAlpha.800"
            fontWeight="500"
            lineHeight="1.35"
            mt="4px"
          >
            Управление клиникой
          </Text>
        </Flex>
      </Flex>
      <Link href={UNITIX_SUPPORT_URL} w="full" position="relative" zIndex={1} isExternal>
        <Button
          w="full"
          h="40px"
          bg={BRAND_ACCENT}
          color="white"
          _hover={{ bg: '#1a6fa3' }}
          _active={{ bg: '#155a86' }}
          fontWeight="600"
          fontSize="sm"
          borderRadius="12px"
          boxShadow="0 4px 12px rgba(43, 139, 196, 0.4)"
        >
          Связаться с поддержкой
        </Button>
      </Link>
    </Flex>
  );
}
